module.exports = {"apiKey":"AIzaSyDwI1u0DwJCYQkYZC270cKoo6yZPRriBp4","authDomain":"sandbox-71899.firebaseapp.com","databaseURL":"https://sandbox-71899.firebaseio.com","projectId":"sandbox-71899","storageBucket":"sandbox-71899.appspot.com","messagingSenderId":"478280055581"}


//////////////////
// WEBPACK FOOTER
// ./src/fb-sandbox.json
// module id = 422
// module chunks = 0